import type { PropsWithChildren } from 'react'
import styled from '@emotion/styled'
import { Modal } from '@retailer-platform/shared-components'
import { Z_INDEX_FIRST } from '../../../../legacy/common/theme'
import { useSurvey } from '../RetailerSatisfactionSurveyContext'
import {
  type NavV3OptOutSurveyPages,
  type NavV3OptOutSurveyState,
  type NavV3OptOutSurveyProps,
} from './NavV3OptOutSurveyController'

const ModalContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '480px',
  maxWidth: '560px',
})

export const NavV3OptOutSurveyModal = ({ children }: PropsWithChildren<{}>) => {
  const { toolProps } = useSurvey<
    NavV3OptOutSurveyPages,
    NavV3OptOutSurveyState,
    NavV3OptOutSurveyProps
  >()

  return (
    <Modal
      maxWidth={560}
      onRequestClose={toolProps.onClose}
      isOpen
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      hideCloseButton={false}
      styleOverrides={{
        content: {
          padding: 0,
          width: 'auto',
        },
        overlay: {
          zIndex: Z_INDEX_FIRST + 1,
        },
      }}
    >
      <ModalContainer>{children}</ModalContainer>
    </Modal>
  )
}
